export default {
  fields: {
    email: 'Indirizzo e-mail',
    postcode: 'Codice postale',
    title: 'Titolo',
    firstName: 'Nome',
    lastName: 'Cognome',
    mobilePhone: 'Numero di cellulare',
    dateOfBirth: 'Data di nascita',
    birthday: 'Compleanno',
    fullAddress: 'Indirizzo completo',
    accept: {
      0: 'accetto il',
      1: 'ho più di 13 anni e accetto il',
      2: 'ho più di 16 anni e accetto il',
      3: 'ho più di 18 anni e accetto il',
      4: 'ho più di 21 anni e accetto il'
    }
  }
};